import { getPackageName } from '@sm/webassets';

/**
 * Get the plan label for the upgrade path to create a private app
 * @returns {plan_label} string
 */
export default function getPlanLabelForFeature(user, feature) {
  const planIds = user.features_upgrade_path[feature];
  if (planIds) {
    return getPackageName(planIds[0]);
  }

  return user.package_name;
}
